import type { AsyncLocalStorage } from "async_hooks";

const req =
  eval("typeof require") === "function"
    ? eval("require")
    : (function () {
        return {};
      } as any);

/* eslint-disable @typescript-eslint/no-var-requires */
export const AsyncLocalStorageIfNode =
  process.env["NX_PUBLIC_APP_ENV"] !== "browser"
    ? (req("async_hooks").AsyncLocalStorage as typeof AsyncLocalStorage)
    : undefined;

export type { AsyncLocalStorage } from "async_hooks";
